import { useIsFormsV2Enabled } from "@/react/components/SettingsApp/Emails/components/Forms/hooks/useIsFormsV2Enabled";
import type {
  Form as FormType,
  FormEmbedDisplayFormat,
} from "@/react/types/Form";
import { FormRenderer as FormRendererV1 } from "../FormRenderer";
import { FormRendererV2 } from "./index";
import type { RenderType } from "./contexts/FormRenderingContext";

interface FormRendererProps {
  embedDisplayFormat?: FormEmbedDisplayFormat;
  form?: FormType;
  id: number;
  index: number;
  isPreview?: boolean;
  isUsedOnPages?: boolean;
  popupDelay?: number;
  popupFrequency?: number;
  renderType?: RenderType;
}
export const FormRenderer = ({
  id,
  index,
  isPreview,
  isUsedOnPages,
  embedDisplayFormat,
  popupFrequency,
  popupDelay,
  renderType,
}: FormRendererProps) => {
  const isFormsV2Enabled = useIsFormsV2Enabled();
  const FormRendererComponent = isFormsV2Enabled
    ? FormRendererV2
    : FormRendererV1;
  return (
    <FormRendererComponent
      id={id}
      index={index}
      isPreview={isPreview}
      isUsedOnPages={isUsedOnPages}
      embedDisplayFormat={embedDisplayFormat}
      popupFrequency={popupFrequency}
      popupDelay={popupDelay}
      renderType={renderType}
    />
  );
};
